import api from '@/api/company'

const state = {
    settings: {},
}

const updateSettings = (settings, configuration) => {
    settings.configurations = settings.configurations || []
    const idx = settings.configurations.find(x => x.key === configuration.key)
    if (idx === -1) {
        settings.configurations.push(configuration)
    } else {
        settings.configurations.splice(idx, 1, configuration)
    }
    console.log('settings', settings)
    return settings
}

const getters = {
    configurations(state) {
        return state.settings.configurations
    },
}

const mutations = {
    set(state, settings) {
        state.settings = settings
    },
}

const actions = {
    fetch({ commit }) {
        return api
            .fetch()
            .then(result => {
                const data = result.data.success.data
                console.log('company data', data)
                commit('set', data)
            })
            .catch(err => {
                throw err
            })
    },
    update({ commit }, model) {
        return api
            .update(model)
            .then(result => {
                console.log('company data', result)
                commit('set', result.data.success.data)
            })
            .catch(err => {
                throw err
            })
    },

    fetchConfiguration({ state, commit }, key) {
        return api
            .fetchConfiguration(key)
            .then(result => {
                console.log('fetchConfiguration data', result)
                const configuration = result.data.success.data
                commit('set', updateSettings(state.settings, configuration))
            })
            .catch(err => {
                throw err
            })
    },

    updateConfiguration({ state, commit }, { key, text_value, bool_value }) {
        return api
            .updateConfiguration({ key, text_value, bool_value })
            .then(result => {
                console.log('company data', result)
                const configuration = result.data.success.data
                commit('set', updateSettings(state.settings, configuration))
            })
            .catch(err => {
                throw err
            })
    },

    deleteConfiguration({ dispatch }, key) {
        return api
            .deleteConfiguration(key)
            .then(() => {
                dispatch('fetch')
            })
            .catch(err => {
                throw err
            })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
